module.exports = __webpack_public_path__ + "img/coin-006.c2dd1d90.svg";